<template>
  <v-container class="main-container d-flex flex-column justify-center">
    <!-- Checkout texts -->
    <RegInfoSummary v-if="!paymentSuccessful" />

    <!-- PAYMENT SUCCESS -->
    <div v-if="paymentSuccessful && !saveFailed" class="text-center" data-test="text-success">
      <v-icon color="#c8e6c9" size="100"> $vuetify.icons.checkboxMarkedCircle </v-icon>
      <div class="text-checkout-sum mt-3">{{ $t("payment_successful_1") }}</div>
      <div class="text-checkout-details mt-2">
        {{ $t("payment_successful_2") }}
      </div>
      <div class="text-checkout-details mt-2" v-if="documentUploadSuccess">
        {{ $t("upload_success") }}
      </div>
    </div>

    <!-- DOCUMENT UPLOAD FAILED -->
    <v-row v-if="documentUploadError && !documentUploadSuccess">
      <v-col cols="12" md="10" offset="0" offset-md="1" class="pt-4 pb-5">
        <v-alert dense color="#f0404f" outlined>
          <v-icon left color="#f0404f"> $vuetify.icons.closeCircle </v-icon
          ><span>{{ $t("upload_error") }} ({{ documentUploadError }})</span></v-alert
        >
      </v-col>
    </v-row>

    <!-- PAYMENT REQUEST BUTTON -->
    <div v-if="!paymentSuccessful">
      <!-- TABS CHOOSER -->
      <v-row v-if="price.finalPrice > 0" class="mb-2">
        <v-col cols="12" md="10" offset-md="1" class="pb-0 pt-0">
          <v-divider></v-divider>
          <v-tabs :color="uiColor" v-model="tab" show-arrows>
            <v-tab>{{ $t("payment_methods.invoice") }}</v-tab>
          </v-tabs>
        </v-col>
      </v-row>

      <!-- SAVE FAILED -->
      <v-row v-if="saveFailed">
        <v-col cols="12" md="10" offset="0" offset-md="1" class="pt-4 pb-5">
          <v-alert dense color="#f0404f" outlined>
            <v-icon left color="#f0404f"> $vuetify.icons.closeCircle </v-icon
            ><span>{{ $t("save_failed") }} ({{ errorCode }})</span></v-alert
          >
        </v-col>
      </v-row>

      <!-- UPLOAD INDICATOR -->
      <v-row v-if="lockSubmit && !documentsEmpty">
        <v-col cols="12" md="10" offset="0" offset-md="1" class="payment-margin mb-5">
          <DocumentUploadIndicator />
        </v-col>
      </v-row>

      <!-- TABS -->
      <v-tabs-items v-model="tab" class="tab-item align-content-start" v-if="price.finalPrice > 0">
        <!-- RECHNUNG -->
        <v-tab-item>
          <v-row>
            <v-col cols="12" md="10" offset="0" offset-md="1">
              <span>
                {{ $t("invoice.text") }}
              </span>
            </v-col>
          </v-row>
          <div class="text-center mt-3 pay-button-margin">
            <v-btn
              v-if="!lockSubmit"
              tile
              large
              :color="uiColor"
              v-on:click.prevent="requestUserSecret('invoice')"
              data-test="button-register"
            >
              <span v-if="documentsEmpty">{{ $t("register") }}</span>
              <span v-if="!documentsEmpty">{{ $t("register_and_upload") }}</span>
            </v-btn>
            <v-progress-circular
              :size="50"
              :width="7"
              :color="uiColor"
              indeterminate
              v-if="lockSubmit"
              :aria-label="$t('loading')"
              :aria-busy="lockSubmit"
              aria-live="polite"
            ></v-progress-circular>
          </div>
        </v-tab-item>
      </v-tabs-items>
      <div>
        <v-btn
          tile
          :color="uiColor"
          :disabled="lockSubmit"
          class="back-button back-button--margin-top"
          v-on:click="$emit('back-button-clicked')"
          >{{ $t("back") }}</v-btn
        >
      </div>
    </div>
  </v-container>
</template>

<script>
import { getUserSecret } from "../services/CheckoutService";
import RegInfoSummary from "./RegInfoSummary";
import { uploadDocuments } from "../services/DocumentUploadService";
import DocumentUploadIndicator from "./DocumentUploadIndicator";
import { logStep } from "../services/LogService";

export default {
  name: "CheckoutInvoice",
  components: {
    RegInfoSummary,
    DocumentUploadIndicator,
  },
  data() {
    return {
      tab: 0,
      lockSubmit: false,
      certificate: this.$store.getters["registration/certificate"],
      language: this.$store.getters["registration/languageName"],
      date: this.$store.getters["registration/date"],
      time: this.$store.getters["registration/time"],
      price: this.$store.getters["registration/calculatedPrice"],
      paymentButtonClicked: false,
      paymentSuccessful: false,
      documentsEmpty: this.$store.getters["registration/documentsEmpty"],
      documents: this.$store.getters["registration/documents"],
      random: this.$store.getters["registration/registrationRandom"],
      uiColor: this.$store.getters["registration/uiColor"],
      saveFailed: false,
      errorCode: null,
      tenant: this.$store.getters["registration/tenant"],
    };
  },
  methods: {
    getDataToSend(paymentMethod) {
      var regInfo = this.$store.getters["registration/registrationData"];
      regInfo.paymentInfo.paymentMethod = paymentMethod;
      return regInfo;
    },
    async requestUserSecret(paymentMethod) {
      this.paymentButtonClicked = true;
      this.lockSubmit = true;
      if (!this.documentsEmpty) {
        this.uploadResult = await uploadDocuments(
          this.$store.getters["registration/env"].documentUploadUrl,
          this.documents,
          this.tenant,
          this.random
        );
        if (Object.keys(this.uploadResult.failed).length === 0) {
          this.documentUploadSuccess = true;
        } else {
          if (Object.values(this.uploadResult.failed[Object.keys(this.uploadResult.failed)[0]])[0].error) {
            this.documentUploadError = Object.values(
              this.uploadResult.failed[Object.keys(this.uploadResult.failed)[0]]
            )[0].error;
          } else {
            this.documentUploadError = true;
          }
        }
      }
      getUserSecret(this.$store.getters["registration/env"].backendUrl, this.getDataToSend(paymentMethod)).then(
        (res) => {
          if (res && !res.error) {
            console.log("user secret successfully obtained");
            switch (paymentMethod) {
              case "none":
                this.lockSubmit = false;
                this.paymentSuccessful = true;
                this.registrationCompleted = true;
                this.saveFailed = false;
                break;
              case "invoice":
                this.lockSubmit = false;
                this.paymentSuccessful = true;
                this.registrationCompleted = true;
                this.saveFailed = false;
                break;
              default:
                break;
            }
            logStep(
              this.random,
              "RegistrationCompletedInvoice",
              this.$store.getters["registration/country"],
              this.$store.getters["registration/language"],
              this.$store.getters["registration/certId"],
              "finish"
            );
          } else {
            console.log("user secret failed");
            this.lockSubmit = false;
            this.saveFailed = true;
            if (res.error && res.status) {
              this.errorCode = res.status;
            }
            logStep(
              this.random,
              "RegistrationFailedInvoice",
              this.$store.getters["registration/country"],
              this.$store.getters["registration/language"],
              this.$store.getters["registration/certId"],
              "finish"
            );
          }
        }
      );
    },
  },
  computed: {
    registrationCompleted: {
      get() {
        return this.$store.getters["registration/registrationCompleted"];
      },
      set(value) {
        this.$store.dispatch("registration/updateRegistrationCompleted", value);
      },
    },
    documentUploadSuccess: {
      get() {
        return this.$store.getters["registration/documentUploadSuccess"];
      },
      set(value) {
        this.$store.dispatch("registration/updateDocumentUploadSuccess", value);
      },
    },
    documentUploadError: {
      get() {
        return this.$store.getters["registration/documentUploadError"];
      },
      set(value) {
        this.$store.dispatch("registration/updateDocumentUploadError", value);
      },
    },
    uploadResult: {
      get() {
        return this.$store.getters["registration/uploadResult"];
      },
      set(value) {
        this.$store.dispatch("registration/updateUploadResult", value);
      },
    },
  },
};
</script>

<style scoped>
.main-container {
  height: 100%;
}
@media (max-width: 960px) {
  .main-container {
    height: fit-content !important;
  }
}

@media (max-width: 450px) {
  .v-tabs {
    max-width: 300px !important;
  }
}

@media (max-width: 320px) {
  .v-tabs {
    max-width: 250px !important;
  }
}

.v-tabs {
  width: auto;
}

.tab-item {
  height: 250px;
}

.textfield-margin {
  margin-bottom: -36px;
}
.tab-item {
  margin-bottom: 40px;
}
.checkbox-margin {
  margin-top: -40px;
}

.payment-button {
  width: 83%;
  margin-left: auto;
  margin-right: auto;
  margin-top: -14px;
  margin-bottom: 14px;
}
</style>
